const FALLBACK_DOMAIN = 'drone-java-api.metop.com.cn'
const FALLBACK_GB_SERVER_IP = '110.42.32.122'
const runtimeLocation = typeof window !== 'undefined' ? window.location : undefined
const useRuntimeHost = !!runtimeLocation && !['localhost', '127.0.0.1'].includes(runtimeLocation.hostname)
const runtimeProtocol = runtimeLocation?.protocol === 'https:' ? 'https:' : 'http:'
const runtimeWsProtocol = runtimeProtocol === 'https:' ? 'wss:' : 'ws:'
const runtimeHost = useRuntimeHost ? runtimeLocation.host : FALLBACK_DOMAIN
const runtimeHostname = useRuntimeHost ? runtimeLocation.hostname : FALLBACK_DOMAIN

export const CURRENT_CONFIG = {

  // license
  appId: '177520', // You need to go to the development website to apply.
  appKey: '9dead91b7b9e58c80bdebbe48eff919', // You need to go to the development website to apply.
  appLicense: 'S+08f29LhJUvFDCyl+tsUh2fnASvOuj/MFiSaRzWSoIK+kIKSitmxS5UHsilsz6TqYTHAYOkkiADaPL1XdAqhwAPpq7iypVs6VAZpCgP8Z48OGq5ddAFZTi6tKw2bPa8W0dTxLoQ3SAJBgOsUvYf4sAJvygW0eMGHxziydN6YtA=', // You need to go to the development website to apply.

  // http
  baseURL: `${runtimeProtocol}//${runtimeHost}/`,
  websocketURL: `${runtimeWsProtocol}//${runtimeHost}/api/v1/ws`,

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: `rtmp://${runtimeHostname}:1935/live/`,
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: runtimeHostname === FALLBACK_DOMAIN ? FALLBACK_GB_SERVER_IP : runtimeHostname,
  gbServerPort: '5060',
  gbServerId: '44010200492000000001',
  gbAgentId: '44010200491320000001',
  gbPassword: 'admin123',
  gbAgentPort: '7060',
  gbAgentChannel: '44010200491320000001',
  // RTSP
  rtspUserName: 'DJIDJI',
  rtspPassword: '123456',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: 'Please enter the amap key.',

}
